// QUAL ITEM DA BARRA ACENDE QUANDO NENHUM NOME DE ROTA CASA (06/10/2026).
//
// A barra de cima acendia só pelos nomes de rota listados à mão em cada item
// (`activeOn`). Toda subtela que ficou fora da lista abria com a barra
// apagada: 10 das 11 telas da Agenda, 37 de Configurações, 14 de Relatórios,
// 12 do Lumos, menções/sem resposta das Conversas (varredura de 06/10).
//
// Regra de reserva: acende o item cujo endereço tem o MAIOR começo em comum
// com a tela aberta (`/appointments/dashboard` → Agenda, que aponta para
// `/appointments/calendar`). O nome de rota continua mandando quando existe.
const DA_CONTA = /^\/app\/accounts\/\d+\/?/;

const pedacos = caminho =>
  String(caminho || '')
    .split(/[?#]/)[0]
    .replace(DA_CONTA, '')
    .split('/')
    .filter(Boolean);

const emComum = (a, b) => {
  let n = 0;
  while (n < a.length && n < b.length && a[n] === b[n]) n += 1;
  return n;
};

// itens: [{ nome, caminhos: ['/app/accounts/1/appointments/calendar', …] }]
export const itemPeloCaminho = (caminhoAtual, itens) => {
  const atual = pedacos(caminhoAtual);
  let melhor = null;
  let maior = 0;
  itens.forEach(({ nome, caminhos }) =>
    caminhos.forEach(caminho => {
      const alvo = pedacos(caminho);
      const comum = emComum(alvo, atual);
      // Empate: vale mais o item cujo endereço INTEIRO é começo da tela
      // (`/processos/27` é de Processos, não do Início em
      // `/processos/dashboard`).
      const n = comum && comum === alvo.length ? comum + 0.5 : comum;
      if (n > maior) {
        maior = n;
        melhor = nome;
      }
    })
  );
  return melhor;
};
